import React from 'react';
import { NewLabel } from '../atoms/labels';
import { renderRichText } from 'gatsby-source-storyblok';
import { LinkWrapper } from '../../utils/link';
import { translateStoryName } from '../../utils/story';
import { getSiteConfig } from '../../../siteConfig';
import FooterLinkItem from './footerLinksItem';

const FooterLinks = ({ content }) => {
  const currentLanguage = getSiteConfig().storyblokLanguage;

  const countryChange = (e) => {
    window.location = e.target.value;
  };
  return (
    <div className="w-full rounded-t-2xl -mt-8 bg-yellow-60 px-2 md:px-0">
      <div className="w-full max-w-screen-xl pt-8 mb-0 px-0 md:px-8 flex flex-col sm:flex-row mx-auto">
        <img
          src={content.secondary_logo.filename}
          alt={content.secondary_logo.alt}
          className="w-32 h-8"
        />
      </div>
      <div className="w-full max-w-screen-xl mx-auto pt-4 mb-6 px-4 md:px-12 flex flex-col lg:flex-row ">
        <div className="w-full lg:w-1/2">
          <div
            className="w-full sm:max-w-[28rem] pr-4 "
            dangerouslySetInnerHTML={{
              __html: renderRichText(content.footer_text),
            }}
          />
        </div>

        <div className="w-full lg:w-1/2 flex flex-wrap lg:pl-8 mt-8 lg:mt-0">
          {content.footer_items.map((item, index) => (
            <div key={item._uid + index} className={`w-1/2 sm:w-1/3 mb-4`}>
              <FooterLinkWrapper
                item={item}
                className="font-medium no-underline opacity-100 hover:opacity-75"
              >
                <h4>
                  {item.use_custom_name_for_link || !item.link.story
                    ? item.text || 'Text not found'
                    : translateStoryName(item.link.story, currentLanguage)}
                </h4>
                {item.link_style === 'new' && <NewLabel />}
              </FooterLinkWrapper>
              <div className="flex flex-col flex-wrap">
                {item.sub_links.map((sub) => (
                  <FooterLinkItem
                    item={sub}
                    key={sub._uid}
                    trackingParent={`footer`}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full max-w-screen-xl mx-auto py-4 flex flex-col sm:flex-row sm:justify-between px-2 md:px-8">
        <div className="w-full sm:w-1/6 sm:pl-0 ">
          <select
            className="mr-4 py-2 pl-2 pr-4 rounded-full bg-yellow-30 text-xs"
            name="countrySelector"
            onChange={(e) => countryChange(e)}
            value={process.env.GATSBY_SITE_SITEURL}
          >
            <option value="https://www.alpresor.se">Sverige</option>
            <option value="https://www.alppimatkat.fi">Suomi</option>
            <option value="https://www.alpereiser.no">Norge</option>
          </select>
        </div>
        <div className="w-full sm:w-auto p-4 sm:p-0 text-xxs black-50">
          © {getSiteConfig().companyName} {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

const FooterLinkWrapper = ({ item, children }) => {
  if (item.link.cached_url) {
    return (
      <LinkWrapper
        link={item.link}
        key={item._uid}
        className="font-medium no-underline opacity-100 hover:opacity-75"
        trackingId={`footer-${item.text}`}
      >
        {children}
      </LinkWrapper>
    );
  } else {
    return (
      <div className={`font-medium no-underline `} key={item._uid}>
        {children}
      </div>
    );
  }
};

export default FooterLinks;
